import { render, staticRenderFns } from "./IndustryContent.vue?vue&type=template&id=145188e5&scoped=true&"
import script from "./IndustryContent.vue?vue&type=script&lang=js&"
export * from "./IndustryContent.vue?vue&type=script&lang=js&"
import style0 from "./IndustryContent.vue?vue&type=style&index=0&id=145188e5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145188e5",
  null
  
)

export default component.exports